import { BusinessTaxCalcParams } from './useBusinessTaxCalc.interface';

/**
 * Query key factory for the business tax calculation. Extracted so the hook and
 * any invalidations can't drift apart — the params are part of the key because
 * every field changes the resulting figures.
 */
const businessTaxCalcKeys = {
    all: ['tax', 'businessTaxCalc'] as const,
    // Spread from `all` rather than restating the prefix, so a change there can't
    // silently break prefix invalidation.
    byParams: (params?: BusinessTaxCalcParams) => [...businessTaxCalcKeys.all, params] as const,
};

export default businessTaxCalcKeys;
